import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { Loaded } from "models/loaded";
import React from "react";
import { MaterialConstraintClass } from "src/store/api/generatedApi";
import {
  FrontendMaterialLimit,
  MaterialLimitsEditor,
} from "components/common/forms/MaterialLimitsEditor";

interface EditorDialogProps {
  doClose: () => void;
  materialLimit: FrontendMaterialLimit;
  title: string;
  onSubmit: (materialLimit: FrontendMaterialLimit) => void;
  onDelete?: () => void;
  materialConstraintClasses: Loaded<MaterialConstraintClass[]>;
}

export const BasketMaterialLimitEditorDialog = ({
  doClose,
  onSubmit,
  onDelete,
  title,
  materialLimit: initialMaterialLimit,
  materialConstraintClasses,
}: EditorDialogProps) => {
  const { t } = useTenantTranslation();
  const [materialLimit, setMaterialLimit] =
    React.useState<FrontendMaterialLimit>(initialMaterialLimit);
  const canSubmit =
    materialLimit.name !== "" &&
    Object.values(materialLimit.coefficients).length > 0;

  return (
    <Dialog
      open
      onClose={doClose}
      maxWidth="xl"
      data-testid="material-limit-editor-dialog"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <MaterialLimitsEditor
          onChange={setMaterialLimit}
          materialLimit={materialLimit}
          materialConstraintClasses={materialConstraintClasses}
        />
      </DialogContent>
      <DialogActions>
        {onDelete ? (
          <Button
            onClick={() => {
              onDelete();
              doClose();
            }}
            color="error"
            sx={{ mr: "auto" }}
            data-testid="material-limit-delete"
          >
            {t("delete")}
          </Button>
        ) : null}
        <Button
          onClick={doClose}
          color="secondary"
          data-testid="material-limit-cancel"
        >
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            if (canSubmit) {
              onSubmit(materialLimit);
              doClose();
            }
          }}
          disabled={!canSubmit}
          data-testid="material-limit-confirm"
        >
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
